import Formatted from "@/components/shared/Formatted";

const COMMON = Wind.style({
    fontFamily: "font-default",
    color: "text-dark-blue",
});

const HEADING = COMMON.compose({
    fontSize: "text-2xl",
    fontWeight: "font-bold",
    lineHeight: "leading-8",
    color: "text-dark-blue",
    marginBottom: "mb-2",
}).class;

const PARAGRAPH = COMMON.compose({
    fontSize: "text-base",
    fontWeight: "font-normal",
    lineHeight: "leading-6",
    paddingTop: "pt-2",
    marginBottom: "mb-6",
}).class;

export default function TextExplanation({children}: { children: string })
{
    return (
        <Formatted
            basic
            components={{
                h1: { className: HEADING },
                p: { className: PARAGRAPH }
            }}
        >
            {children}
        </Formatted>
    );
}
